import { timeBadgeLabel } from "../../lib/copy";

/**
 * WindowGauge — shows days left before opportunity decays.
 * Color is a function of days, not "priority", so it stays honest.
 *
 * El texto también depende del motor (engineId): solo Renovación tiene un
 * vencimiento real detrás de `days` — Recuperación y Venta cruzada usan una
 * ventana sintética de urgencia recomendada (ver lib/copy.js), así que
 * decir "Vence" ahí sería un dato falso, no solo una preferencia de estilo.
 */
export default function WindowGauge({ days, engineId, compact = false }) {
  const tone =
    days <= 7 ? "text-red-400 border-red-500/40 bg-red-500/10"
    : days <= 21 ? "text-amber-400 border-amber-500/40 bg-amber-500/10"
    : "text-zinc-400 border-zinc-700 bg-zinc-500/5";
  return (
    <span
      className={`text-[10px] font-mono uppercase tracking-[0.15em] px-1.5 py-0.5 rounded-full border tabular-nums whitespace-nowrap ${tone}`}
    >
      {timeBadgeLabel(engineId, days, { compact })}
    </span>
  );
}
